import styled from 'styled-components'

export const Divider = styled.div`
  width: 100%;
  background: #dfe2e6;
  height: 1px;
`

export const VerticalDivider = styled.div`
  width: 1px;
  background: #dee2e6;
  height: 100%;
`
